module.exports = __webpack_public_path__ + "img/icons8-bmw.debd24ea.svg";